import './configuratorManualFeModaEditProductName.scss';

class ConfiguratorManualFeModalEditProductName {
    constructor($http, $window, close, translateService, product) {
        'ngInject';

        this.$http = $http;
        this.product = product;
        this.closeCallback = close;
        this.error = false;
        this.translate = translateService;

        this.product_name = product.product_name;
        this.user_product_name = product.user_product_name;
        this.user_product_name_without_suffix = product.user_product_name_without_suffix;
    }

    save() {
        this.error = false;

        this.closeCallback({
            product: this.product,
            user_product_name: this.user_product_name,
            user_product_name_without_suffix: this.user_product_name_without_suffix
        }, 200);
    }

    close() {
        this.closeCallback(false, 200);
    }
}

export default ConfiguratorManualFeModalEditProductName;
